export default {
  coffeeData: {
    windBreaker: "Albero di rottura del vento",
    horticultureInfo: "Albero di orticoltura",
    shadeTree: "Albero di ombre",
    coffeeVariety: "Varietà di caffè",
    coffeeSpecies: "Specie di caffè",
    updateWindBreaker: "Aggiorna il vento Tipo di albero di rottura",
    addWindBreaker: "Aggiungi nuovo ventoBreaker Tipo albero",
    updateHorticultureInfo:
      "Aggiornamento orticoltura Informazioni Tipo albero",
    addHorticultureInfo: "Aggiungi nuova orticoltura Informazioni Tipo albero",
    updateShadeTree: "Aggiorna l'ombra Tipo albero albero",
    addShadeTree: "Aggiungi nuova tonalità Tipo albero albero",
    updateCoffeeVariety: "Aggiornare il caffè Tipo di albero variegato",
    addCoffeeVariety: "Aggiungi nuovo caffèVariety Albero Tipo",
    deleteVarietyTitle: "Eliminare la varietà",
    deleteVarietyMessage: "Sei sicuro di voler eliminare Variety?",
    updateCoffeeSpecie: "Aggiornamento Caffè Specie",
    deleteSpecieTitle: "Eliminare la specie",
    deleteSpecieMessage: "Sei sicuro di voler eliminare Specie?",
    addCoffeeSpecie: "Aggiungere Nuova varietà di caffè",
    variety: "Varietà",
    selectVariety: "Selezionare Specie",
    deleteCoffeeRecord: "Sei sicuro di voler eliminare il record?",
    deleteCoffeeData: "Eliminare i dati del caffè",
    topicRequired: "Seleziona argomento è necessario",
    coffeeAddSuccess: "Caffè Specie aggiunto con successo.",
    treeTypeSuccess: "Tipo di albero aggiunto con successo.",
    treeTypeUpdateSuccess: "Tipo di albero aggiornato con successo.",
    coffeeVarietySuccess: "Varietà di caffè aggiunto con successo.",
    coffeeSpecieSuccess: "Caffè specie aggiornato con successo.",
    nameRequired: "Il nome è richiesto",
    notFound: "No Admin Dati del caffè Trovato",
  },
  cacaoData: {
    cacao: "Cacao",
    cacaoVariety: "Varietà di Cacao",
    cacaoSpecies: "Cacao Specie",
    cacaoWeight: "Cacao Peso",
    cacaoOverview: "Cacao Panoramica",
    cacaoType: "Cacao Tipo",
    deleteCacaoData: "Eliminare i dati di Cacao",
    productWeight: "Peso del prodotto",
    productType: "Tipo di prodotto",
    productPricePerKg: "Prezzo per KG",
    registerFermentation: "Fermentazione del registro",
    batchVisualIdentification: "Indentificazione visiva batch",
    initialWeight: "Peso iniziale",
    finalWeight: "Peso finale",
    performance: "Prestazioni",
    fermentationPercentage: "Percentuale di fermentazione",
    fermetationMethod: "Metodo di fermentazione",
    boxes: "Boxe",
    piles: "Celle",
    bags: "Borse",
    selectZone: "Seleziona la zona",
    selectPlantation: "Seleziona la piantagione",
    deliveryMethod: "Metodo di consegna",
    totalPrice: "Prezzo totale",
  },
  memberDataSection: {
    import: "Importazioni",
    buyingStation: "Comprare la stazione",
    continue: "Continua",
    farmerId: "ID azienda agricola",
    farmerName: "Nome del coltivatore",
    farmerAddress: "Farmer Indirizzo",
    quality: "Qualità",
    quantity: "Quantità",
    importAll: "Importa tutto",
    importSelected: "Importo selezionato",
    fileLoaded: "File caricato con successo",
    incorrectHeaders: "Intestazioni scorrette",
    processingBatch: "Elaborazione Batch",
    purchaseOrder: "Ordine di acquisto",
    startDate: "Data di inizio",
    endDate: "Data di fine",
    selectCrop: "Seleziona Coltura",
    purchasingOrder: "Ordine di acquisto",
    totalCoffeeCherry: "Ciliegia totale del caffè",
    airHumidity: "Umidità dell'aria",
    density: "Densità",
    temperature: "Temperatura",
    beanMoistureContent: "Contenuto della piantagione di fagioli",
    processType: "Tipo di processo",
    batchRating: "Seleziona la valutazione del batch",
    purchaseDate: "Data di acquisto",
    selectFarmer: "Seleziona Farmer",
    selectFarmers: "Seleziona Farmers",
    selectFarm: "Seleziona Agriturismo",
    selectPlantation: "Seleziona la piantagione",
    coffeeVariety: "Varietà di caffè",
    coffeeSpecies: "Specie di caffè",
    coffeeCherryQuantity: "Ciliegia di caffè quantità",
    coffeeCherryQuality: "Qualità del caffè",
    coffeeType: "Tipo di caffè",
    pricePerKg: "Prezzo per Kg",
    processingDone: "Fatto di elaborazione",
    processedCoffeeOut: "Caffè lavorato fuori",
    farmer: "Farmer",
    farm: "Fattoria",
    plantation: "Piantatura",
    farmers: "Agricoltori",
    farmLimitUsed: "Limite di fattoria utilizzato",
    phoneNumber: "Numero di telefono",
    farmSize: "Dimensione della fattoria",
    farmLocation: "Fattoria/Locazione",
    date: "Data",
    status: "Stato",
    noFarmers: "Nessun Agriturismo Trovato",
    approveReject: "Approvo/Rigetto",
    farms: "Aziende agricole",
    crops: "Croci",
    equipment: "Attrezzatura",
    noFarms: "Nessun agriturismo Trovato",
    views: "Vista",
    selectStatus: "Selezionare Stato",
    approved: "Approvazione",
    rejected: "Rifiuti",
    reject: "Rifiuti",
    approve: "Approvo",
    conclude: "Concludi",
    cancel: "Annulla",
    add: "Aggiungi",
    describeYourReason: "Descrivi il tuo motivo qui",
    userInformation: "Informazioni utente",
    userFarmRequest: "Richiesta dell'utente",
    userFarmInformation: "User Farm(s) Informazioni",
    activity: "Attività",
    activityType: "Tipo di attività",
    farmZone: "Zona agricola",
    farmerView: "Vista sul mare",
    cropType: "Tipo di coltura",
    cropVarity: "Varietà del raccolto",
    area: "Settore",
    cost: "Costo",
    geofence: "Geofence",
    map_views: "Visualizza mappa",
    viewAllFarms: "Visualizza tutti gli agriturismi",
    farmersDetails: "Dettagli dell'agriturismo",
    download: "Scarica",
    pOrder: {
      addNew: "Aggiungi nuovo",
      viewAll: "Vedi tutto",
      selectDate: "Seleziona la data",
      makeSelection: "Fai una selezione",
      coffeeType: "Tipo di caffè quantità",
      enterPrice: "Inserisci il prezzo",
      reqPurchaseDate: "La data di acquisto è richiesta",
      reqFarmer: "L'agricoltore è richiesto",
      reqCoffeeQnty: "Ciliegia di caffè Quantità è richiesto",
      reqPrice: "Prezzo per Kg è richiesto",
      grandTotal: "GRAND TOTALE",
      selectDateRange: "Seleziona l'intervallo di date",
      import: "Importazioni",
      purchaseId: "Acquisto Id",
      purchaseDate: "Data di acquisto",
      farmerName: "Nome del coltivatore",
      quality: "Qualità",
      quantity: "Quantità",
      pricePerKg: "Prezzo per Kg",
      selectBuyingStation: "Selezionare la stazione di acquisto",
      searchUser: "Utenti di ricerca",
      calendarView: "Calendario vista",
      purchaseListView: "Lista di acquisto",
      viewBy: "Vista da",
      typeDensity: "Tipo Densità",
      typeTemperature: "Tipo di temperatura",
      typeWaterContent: "Tipo contenuto di acqua",
    },
    farmActivity: "Attività agricola",
    showOnMap: "Mostra sulla mappa",
    farmInformation: "Informazioni sull'azienda",
    dateOfEntry: "Data di entrata",
    farmID: "ID azienda agricola",
    ownershipType: "Tipo di proprietà",
    locationAddress: "Indirizzo",
    goalType: "Tipo di gol",
    totalSize: "Dimensione totale",
    zones: "Zone",
    farmActivities: "Farm Activites",
    farmDetails: "Dettagli dell'agriturismo",
    totalFarmsRegistered: "Totale aziende",
    totalFarmArea: "Totale superficie agricola",
    totalZone: "Zona totale",
    zone: "Zona",
    totalCost: "Costo totale",
    selectFarmZone: "Seleziona Zona/Farm",
    productionType: "Tipo di produzione",
    certifications: "Certifications",
    geofences: "Geofences",
    farmsChart: "Grafico delle fattorie",
  },
  registerNewAffiliate: "Registra Nuovo Afiliado",
  selectHowYouWantToProceed: "Seleziona come vuoi procedere",
  single: "Single",
  multiple: "Multiple",
  user: "User",
  createNewAffiliate: "Crea Nuovo Afiliado",
  affiliateName: "Nome dell'Afiliado",
  affiliateNumber: "Numero dell'Afiliado",
  firstName: "Nome",
  lastName: "Cognome",
  primaryEmailAddress: "Email Principale",
  submit: "Invia",
};
